const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
const nonempty = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;
export function isSpineJson(value: unknown): boolean {
  return (
    isObject(value) &&
    isObject(value.skeleton) &&
    nonempty(value.skeleton.spine) &&
    Array.isArray(value.bones) &&
    value.bones.length > 0 &&
    value.bones.every((bone: unknown) => isObject(bone) && nonempty(bone.name))
  );
}
export async function detectSpineJson(
  { src, signal }: { src: string; signal: AbortSignal },
  { fetchFn = fetch }: { fetchFn?: typeof fetch } = {},
): Promise<boolean> {
  signal.throwIfAborted();
  if (!src) throw new Error('Original source URL is missing');
  const response = await fetchFn(src, { signal });
  signal.throwIfAborted();
  if (!response.ok) throw new Error(`Source request failed: ${response.status}`);
  const text = await response.text();
  signal.throwIfAborted();
  try {
    return isSpineJson(JSON.parse(text));
  } catch {
    return false;
  }
}
